export const imageFileExtension = ".jpg, .jpeg, .png";
export const documentFileExtension = ".pdf";
export const iconFileExtension = ".png";
export const maxFileUploadSize = 50000000; // 50 MB
